jQuery('.mega-menu').each(function() {
    var totalChildren = $(this).children('ul').children('li').length;
   if(totalChildren == 13) {
		$(this).addClass('has13ormore');
	}
     if(totalChildren > 15) {
        $(this).addClass('has15ormore');
    } else if(totalChildren > 30) {
        $(this).addClass('has30ormore');
    } else if(totalChildren > 45) {
        $(this).addClass('has45ormore');
    } else	if(totalChildren > 11) {
        $(this).addClass('has11ormore');
    } 
});